import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function Markdown({ children }) {
  return (
    <div className="ssg-md text-[15px] leading-relaxed text-slate-200 space-y-3 break-words">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h1 className="text-xl font-bold text-white mt-2 mb-1 font-head" {...p} />,
          h2: (p) => <h2 className="text-lg font-bold text-white mt-2 mb-1 font-head" {...p} />,
          h3: (p) => <h3 className="text-base font-semibold text-emerald-300 mt-2 mb-1 font-head" {...p} />,
          p: (p) => <p className="leading-relaxed" {...p} />,
          ul: (p) => <ul className="list-disc pl-5 space-y-1" {...p} />,
          ol: (p) => <ol className="list-decimal pl-5 space-y-1" {...p} />,
          li: (p) => <li className="marker:text-emerald-400/70" {...p} />,
          strong: (p) => <strong className="font-semibold text-white" {...p} />,
          a: (p) => <a className="text-emerald-400 underline underline-offset-2 hover:text-emerald-300" target="_blank" rel="noreferrer" {...p} />,
          blockquote: (p) => <blockquote className="border-l-2 border-emerald-500/50 pl-3 text-slate-300 italic" {...p} />,
          table: (p) => <div className="overflow-x-auto my-2 rounded-lg border border-white/10"><table className="w-full text-sm" {...p} /></div>,
          thead: (p) => <thead className="bg-white/5 text-slate-300" {...p} />,
          th: (p) => <th className="px-3 py-2 text-left font-semibold border-b border-white/10" {...p} />,
          td: (p) => <td className="px-3 py-2 border-b border-white/5 text-slate-300" {...p} />,
          pre: (p) => <div {...p} />,
          code: ({ className, children, ...props }) => {
            const isBlock = /language-/.test(className || "") || String(children).includes("\n");
            return isBlock ? (
              <pre className="my-2 overflow-x-auto rounded-xl bg-[#0A0E16] border border-white/10 p-3 text-[13px] font-mono text-slate-200">
                <code className={className} {...props}>{children}</code>
              </pre>
            ) : (
              <code className="px-1.5 py-0.5 rounded bg-black/40 text-emerald-300 font-mono text-[13px]" {...props}>{children}</code>
            );
          },
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
